<template>
  <div id="app">
    <router-view />
  </div>
</template>



<script>


export default {

};

</script>


<style lang="scss">
@import "@/style/main.scss";


// ------------- MIXINS ------------- //
@mixin transition($time, $property: all, $easing: ease-in) {
    transition: $property $time $easing;
}

// ------------- VARIABLES ------------- //
$parallax-offset:50vh;
$content-offset: 40vh;
$transition-speed: 1.2s;
$slide-number: 3;


html, body {
  overflow: hidden;

    @include media_tablet() {
        overflow: auto;
    }
}



.background {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow: hidden;
  will-change: transform;
  backface-visibility: hidden;
  height: 100vh + $parallax-offset;
  position: fixed;
  width: 100%;
  transform: translateY($parallax-offset);
  @include transition($transition-speed, all, cubic-bezier(0.22, 0.44, 0, 1));

  @include media_tablet() {
    background-size: initial;
    background-repeat: no-repeat;
    background-position: center center;
    overflow: initial;
    will-change: transform;
    backface-visibility: hidden;
    height: auto;
    position: initial;
    width: 100%;
    transform: none;
  }


  &:first-child {

    .content-wrapper {
      transform: translateY($parallax-offset /2);
      @include media_tablet() {
        transform: none;
      }
    }
  }
}


@for $i from 1 to ($slide-number + 1) {
    .background:nth-child(#{$i}) {
        z-index: ($slide-number + 1) - $i;
    }
}

.content {
  &-wrapper {
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column nowrap;
  color: #fff;
  margin: 0 auto;
  transform: translateY($content-offset);
  will-change: transform;
  backface-visibility: hidden;
  @include transition($transition-speed + .5, all, cubic-bezier(0.22, 0.44, 0, 1));

    @include media_tablet() {
        transform: none;
        height: auto;
    }
  }
}

// ------------- SET TRANSFORM VALUES ------------- //

.background.up-scroll {
  transform: translate3d(0,-$parallax-offset / 2,0);
  @include media_tablet() {
      transform: initial;
  }
  .content-wrapper {
    transform: translateY($parallax-offset / 2);
    @include media_tablet() {
      transform: initial;
    }
  }
  + .background {
    transform: translate3d(0,$parallax-offset,0);
    @include media_tablet() {
      transform: initial;
    }
      .content-wrapper {
        transform: translateY($parallax-offset);
        @include media_tablet() {
         transform: initial;
        }
      }
    }
}

.background.down-scroll {
  transform: translate3d(0,-(100vh + $parallax-offset),0);
  @include media_tablet() {
    transform: initial;
  }
  .content-wrapper {
    transform: translateY($content-offset);
    @include media_tablet() {
        transform: initial;
    }
  }
  + .background:not(.down-scroll) {
    transform: translate3d(0,-$parallax-offset / 2,0);
        @include media_tablet() {
            transform: initial;
        }
      .content-wrapper {
        transform: translateY($parallax-offset / 2);
        @include media_tablet() {
            transform: initial;
        }
      }
  }
}

</style>

